module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_animal_structure_and_function_5-261ea2d61ae1b430970acd924d76aef5.jpg";